module.exports = __webpack_public_path__ + "static/media/logo_light.5ea276c9.svg";